import history from "../history";
import { store } from "../index";
import { clearBookmarks } from "../redux/actions/bookmarkActions";

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("millId");
  localStorage.setItem("userPrivileges", "basic_user");
  localStorage.removeItem("userId");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("userMargin");

  try {
    store.dispatch(clearBookmarks());
  } catch (err) {
    console.error("Failed to clear bookmarks on logout:", err);
  }

  history.push(process.env.PUBLIC_URL + "/login-register");
};
